import "./newHome.scss";
import IntroVideoWebM from "assets/video/intro_videoBG.webm";
import React, { useEffect } from "react";
import OceanBay from "./components/oceanBay/OceanBay";
import Vengeance from "./components/vengeance/Vengeance";
import CrimsonOak from "./components/crimsonOak/CrimsonOak";
import InnerChaos from "./components/innerChaos/InnerChaos";
import SweetSmoke from "./components/sweetSmoke/SweetSmoke";
import SEO from "components/seo/SEO";
import MyLoader from "components/myLoader/MyLoader";
import imageLoadStore from "store/imageLoadStore";

const NewHome = () => {
  const ImageLoadStore = imageLoadStore();
  useEffect(() => {
    window.scrollTo({ top: 0 });
    if (ImageLoadStore.imageLoading) {
      setTimeout(() => {
        document.body.style.overflowY = "hidden";
      }, 50);
    }
  }, []);

  // const handleVideoEnd = () => {
  //   document.body.style.overflow = "auto";
  //   document.body.style.overflowX = "hidden";
  // };

  return (
    <>
      <SEO
        title="Kristive Perfumes | Luxury Fragrances for Men & Women"
        description="Experience luxury with Kristive's exquisite perfume collection. Fragrances for men and women, blending rare ingredients with timeless artistry. Discover your signature scent today."
      />
      {ImageLoadStore.imageLoading && (
        <div className="loading">
          <MyLoader height="100vh" />
        </div>
      )}
      <div className="new-home-page">
        <div className="hero">
          <div className="tag-line">Crafted, Just For You.</div>
          <div className="new-home-carousel">
            <video
              autoPlay
              muted
              playsInline
              preload="auto"
              onLoadedData={() => {
                ImageLoadStore.setImageLoading(false);
                document.body.style.overflowY = "scroll";
              }}
              //  onEnded={handleVideoEnd}
            >
              <source src={IntroVideoWebM} type="video/webm" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
        <div className="brand-idea">
          <div className="container">
            <h1>Welcome to Kristive</h1>
            <div className="content">
              <p>
                Kristive was born from a simple yet profound realization the
                most beautiful and meaningful things in life are often those
                crafted with care, intention, and a personal touch. We believe
                that every product has a story to tell, and every story deserves
                to be told with passion and authenticity.
              </p>
              <p>
                As a collective of artisans, designers, and dreamers, we are
                dedicated to creating fragrances that are not only beautiful and
                functional but also deeply meaningful and inspiring. Our brand
                is a celebration of creativity, individuality, and the simple
                joy of making something truly special for you.
              </p>
            </div>
          </div>
        </div>

        <OceanBay />
        <Vengeance />
        <CrimsonOak />
        <InnerChaos />
        <SweetSmoke />
      </div>
    </>
  );
};

export default NewHome;
